
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export const useProfileCompleteness = () => {
  const [isComplete, setIsComplete] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { user } = useAuth();

  useEffect(() => {
    const checkProfileCompleteness = async () => {
      if (!user) {
        setIsLoading(false);
        return;
      }

      try {
        // Get profile completion status from database
        const { data: profileData } = await supabase
          .from("profiles")
          .select("is_profile_complete")
          .eq("id", user.id)
          .single();

        setIsComplete(profileData?.is_profile_complete || false);
      } catch (error) {
        console.error("Error checking profile completeness:", error);
        setIsComplete(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkProfileCompleteness();
  }, [user]);

  // Helper function to update completion status after profile changes
  const updateCompletionStatus = async () => {
    if (!user) return;
    
    try {
      // Call the database function to recalculate and update status
      const { data } = await supabase.rpc('calculate_profile_completeness', {
        target_user_id: user.id
      });
      
      // Update the profile with the new status
      await supabase
        .from('profiles')
        .update({ is_profile_complete: data })
        .eq('id', user.id);
        
      setIsComplete(data || false);
    } catch (error) {
      console.error("Error updating profile completion status:", error);
    }
  };

  return {
    isComplete,
    isLoading,
    updateCompletionStatus
  };
};
